import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown, faCaretLeft, faCaretUp, faKey, faMinus, faPencilAlt, faPlus, faSearch, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';

library.add(faCaretDown, faCaretLeft, faCaretUp, faKey, faMinus, faPencilAlt, faPlus, faSearch, faTimes, faTrash);
